import { render } from "./PaymentHistory.vue?vue&type=template&id=39c70360&scoped=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"

import "./PaymentHistory.vue?vue&type=style&index=0&id=39c70360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c70360"]])

export default __exports__